// extracted by mini-css-extract-plugin
export default {"wrapper":"Link_wrapper__bT+T7","underline":"Link_underline__NKFVB"};